import React, { useState } from "react";
import SharedHelmet from "../.././Helmet";
import imgUrl from "../../../../images/age-year.webp";

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const TITLE = `Calculatrice d'Âge des Personnes Nées de 1960 à ${currentYear} | Précision Maximale`;
const DESCRIPTION = `Calculez votre âge maintenant avec une grande précision si vous êtes né(e) entre 1960 et ${currentYear}. Une calculatrice d'âge détaillée vous affiche le nombre d'années, de mois et de jours depuis votre date de naissance jusqu'à aujourd'hui. Convient aux personnes nées dans les années 60, 70, 80, 90, 2000 et 2010 jusqu'à ${currentYear}.`;
const KEYWORDS = `
calculatrice âge,
calcul âge,
quel est mon âge maintenant,
âge nés 1960,
âge nés 1970,
âge nés 1980,
âge nés 1990,
âge nés 2000,
âge nés 2010,
nés 1960 quel âge ont-ils,
nés 1970 quel âge ont-ils,
nés 1980 quel âge ont-ils,
nés 1990 quel âge ont-ils,
nés 2000 quel âge ont-ils,
nés 2010 quel âge ont-ils,
quel âge ont les nés 1960,
quel âge ont les nés 1970,
quel âge ont les nés 1980,
quel âge ont les nés 1990,
quel âge ont les nés 2000,
quel âge ont les nés 2010,
calcul âge en années mois et jours,
âge nés de 1960 à ${currentYear}
`.trim();
const OG_URL = "https://do-calculate.com/calculator/fr/gregorian/gregorian-year-list/";

function GregorianYearsList() {
    const [searchTerm, setSearchTerm] = useState("");
    const years = Array.from({ length: currentYear - 1960 + 1 }, (_, i) => 1960 + i);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredYears = years.filter(year =>
        year.toString().includes(searchTerm)
    );

    return (
        <div className="container">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                OG_IMAGE={imgUrl}
            />
            <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
            <hr />
            <div className="alert alert-secondary" role="alert">
                <p>{DESCRIPTION}</p>
            </div>
            <hr />
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingBottom: "15px",
                }}
            >
                <h2 style={{ margin: 0 }}>Rechercher une année de naissance</h2>
                <input
                    type="text"
                    placeholder="Rechercher une année..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        width: "200px",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                />
            </div>
            <table className="bmi-table" style={{ width: "100%", tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th>Année de naissance</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredYears.map((year, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <a href={`/calculator/fr/gregorian/${year}/`}>
                                        Nés en {year}
                                    </a>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="mt-4 p-3 bg-light rounded">
                <h3>Comment utiliser la calculatrice :</h3>
                <ul>
                    <li>Choisissez l'année de naissance dans le tableau ci-dessus</li>
                    <li>Vous serez redirigé vers la page de la calculatrice pour cette année</li>
                    <li>Entrez le jour et le mois de naissance pour connaître votre âge exact</li>
                </ul>
            </div>
        </div>
    );
}

export default GregorianYearsList;
